import React from 'react';

import PropTypes from 'prop-types';

import {
    localize,
} from 'wanderu-i18n';

import chikuHeader from 'wanderu-assets/images/chiku-wink.svg';

import styles from './PageDialogWrapper.scss';

function PageDialogWrapper(props) {
    const {
        children,
        className = '',
        t,
        title = '',
    } = props;

    return (
        <div className={`${className} ${styles.container}`}>
            <img
                alt={t('welcome-chiku')}
                className={styles.chikuHeader}
                src={chikuHeader}
            />
            {title && (
                <div className={styles.titleContainer}>
                    {title}
                </div>
            )}
            <div className={styles.childContainer}>
                {children}
            </div>
        </div>
    );
}

PageDialogWrapper.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    t: PropTypes.func,
    title: PropTypes.string,
};

export { PageDialogWrapper };
export default localize(PageDialogWrapper, ['t'], 'baseApp');
